export const environment = {
  remote: false,
  realm: 'tamwilcom-dev',
  url: 'https://keycloak.neosys.business/',
  clientId: 'tamwilcom-front',

  SERVER_REFERENTIEL_API_URL: 'https://tamwilcom-referentiel.neosys.business',
  SERVER_EDITION_API_URL: 'https://tamwilcom-edition.neosys.business',
  SERVER_UTILISATEUR_API_URL: 'https://tamwilcom-utilisateur.neosys.business',
  SERVER_NOTIFICATION_API_URL: 'https://tamwilcom-notification.neosys.business',
  SERVER_REGLE_API_URL: 'https://tamwilcom-regle.neosys.business',
  SERVER_CHARGEMENT_API_URL: 'https://tamwilcom-chargement.neosys.business',
  SERVER_READ_API_URL: 'https://tamwilcom-backoffice.neosys.business',
  SERVER_WORKFLOW_API_URL: 'https://tamwilcom-workflow.neosys.business',
  SERVER_BACKOFFICE_API_URL: 'https://tamwilcom-backoffice.neosys.business',
  SERVER_PLANIFICATION_API_URL: 'https://tamwilcom-planification.neosys.business',
  SERVER_MEJ_API_URL: 'https://tamwilcom-mej.neosys.business',
  SERVER_CFT_API_URL: 'https://tamwilcom-cft.neosys.business',
};
